import { useState, useCallback, useMemo, useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import HowItWorks from "@/components/landing/HowItWorks";
import Projects from "@/components/landing/Projects";
import Certificate from "@/components/landing/Certificate";
import Counter from "@/components/landing/Counter";
import FAQ from "@/components/landing/FAQ";
import CTA from "@/components/landing/CTA";
import Footer from "@/components/landing/Footer";
import WhatsAppSticky from "@/components/landing/WhatsAppSticky";
import LeadDialog from "@/components/landing/LeadDialog";
import { fetchSiteContent } from "@/lib/api";
import { setPageMeta } from "@/lib/pageMeta";

export default function LandingPage() {
  const [dialog, setDialog] = useState({ open: false, type: "meeting" });
  const [siteContent, setSiteContent] = useState({});

  const openMeeting = useCallback(() => setDialog({ open: true, type: "meeting" }), []);
  const openBulk = useCallback(() => setDialog({ open: true, type: "bulk" }), []);
  const closeDialog = useCallback(() => setDialog((d) => ({ ...d, open: false })), []);

  const leadHandlers = useMemo(() => ({ openMeeting, openBulk }), [openMeeting, openBulk]);

  useEffect(() => {
    let alive = true;
    fetchSiteContent().then((c) => { if (alive) setSiteContent(c || {}); }).catch(() => {});
    setPageMeta({
      title: "Green Gift — Plant a Tree with Every Corporate Hamper | Utsah",
      description: "One gift. One tree. Every Utsah hamper plants a tree in a verified reforestation project across India, in your company's name.",
      canonicalPath: "/give-back",
    });
    return () => { alive = false; };
  }, []);

  return (
    <div className="utsah-app">
      <Nav onBookMeeting={openMeeting} />
      <Hero onStartPlanting={openMeeting} siteContent={siteContent} />
      <HowItWorks />
      <Projects />
      <Certificate />
      <Counter />
      <FAQ />
      <CTA />
      <Footer handlers={leadHandlers} />
      <WhatsAppSticky />

      <LeadDialog
        open={dialog.open}
        type={dialog.type}
        onOpenChange={(v) => (v ? null : closeDialog())}
      />

      <Toaster
        position="bottom-center"
        richColors
        theme="light"
        toastOptions={{
          style: {
            fontFamily: "Manrope, system-ui, sans-serif",
            fontWeight: 500,
          },
        }}
      />
    </div>
  );
}
